import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, ArrowUpRight } from "lucide-react";
import { api, COMPANY } from "@/lib/api";
import { SERVICE_LIST } from "@/content/services";
import { Logo } from "./Navbar";

const Col = ({ title, links, testId }) => (
  <div data-testid={testId}>
    <p className="eyebrow text-[var(--terracotta)] mb-6">{title}</p>
    <ul className="space-y-2.5">
      {links.map(([to, label]) => <li key={to}><Link to={to} className="link-underline text-sm text-[var(--cream)]/85 hover:text-[var(--cream)]">{label}</Link></li>)}
    </ul>
  </div>
);

export const Footer = () => {
  const [cats, setCats] = useState([]);
  useEffect(() => { api.get("/categories").then((r) => setCats(r.data.filter((c) => c.brand_count > 0).slice(0, 10))).catch(() => {}); }, []);

  return (
    <footer className="bg-[var(--ink)] text-[var(--cream)] relative border-t-4 border-[var(--terracotta)]" data-testid="site-footer">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4 md:col-span-2">
            <Logo light className="[&>img]:h-10 sm:[&>img]:h-11" />
            <p className="mt-6 max-w-sm text-[var(--stone)] font-light leading-relaxed text-sm">
              Deliver is a Sydney food distributor, wholesale food supplier and SQF accredited high care food processor. We supply independent supermarkets, grocers, delis, cafes, restaurants and foodservice businesses across NSW, ACT and south-east Queensland with premium Australian and imported food ranges.
            </p>
            <Link to="/become-a-stockist" data-testid="footer-cta-stockist" className="btn-pill btn-terracotta mt-8">Open a trade account <ArrowUpRight size={14} /></Link>
          </div>
          <div className="lg:col-span-2"><Col testId="footer-explore" title="Explore" links={[["/brands", "Brands & Range"], ["/about", "About Deliver"], ["/become-a-stockist", "Become a stockist"], ["/contact", "Contact"]]} /></div>
          <div className="lg:col-span-2"><Col testId="footer-services" title="Services" links={SERVICE_LIST.map((s) => [s.path, s.navLabel])} /></div>
          <div className="lg:col-span-2"><Col testId="footer-categories" title="Wholesale categories" links={cats.map((c) => [`/range/${c.slug}`, c.name])} /></div>
          <div className="lg:col-span-2">
            <p className="eyebrow text-[var(--terracotta)] mb-6">Sydney head office</p>
            <address className="not-italic space-y-2.5 text-sm text-[var(--cream)]/85 font-light">
              <p>{COMPANY.address}</p>
              <p><a href={COMPANY.phoneHref} className="link-underline" data-testid="footer-phone">{COMPANY.phone}</a></p>
              <p><a href={`mailto:${COMPANY.email}`} className="link-underline" data-testid="footer-email">{COMPANY.email}</a></p>
              <p className="text-[var(--stone)] text-xs">{COMPANY.hours}</p>
            </address>
            <a href={COMPANY.instagram} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 mt-5 text-sm text-[var(--stone)] hover:text-[var(--cream)] transition-colors" data-testid="footer-instagram"><Instagram size={16} /> @deliver_food</a>
          </div>
        </div>
        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[var(--stone)]">
          <p>© {new Date().getFullYear()} {COMPANY.name}. ABN {COMPANY.abn}. All rights reserved.</p>
          <p>SQF accredited · HACCP · Meat & dairy licensed · <Link to="/admin/login" className="hover:text-[var(--cream)]" data-testid="footer-staff-login">Staff login</Link></p>
        </div>
      </div>
    </footer>
  );
};
